<script setup lang="ts">
import { useOnTimezoneChange } from '@entities/viewer'
import { AppRoute } from '@shared/config'

import { abortTutorAttendanceRatesApi, useTutorAttendanceRatesApi } from '../api/list.hook'
import TableTutorAttendanceRates from './TableTutorAttendanceRates.vue'

defineOptions({
  name: 'TutorAttendanceRatesPage',
})

const route = useRoute()

onMounted(() => {
  void useTutorAttendanceRatesApi()
})

// Filters, pagination and the sidebar link all navigate by query; refetching here keeps the table
// in sync with the URL, including a sidebar click while already on this page.
watch(() => route.query, () => {
  if (route.path === AppRoute.TutorAttendanceRates) {
    void useTutorAttendanceRatesApi()
  }
})

// Lesson starts arrive pre-shifted into the admin's view timezone, so a timezone change needs a refetch.
useOnTimezoneChange(() => {
  void useTutorAttendanceRatesApi()
})

onBeforeUnmount(abortTutorAttendanceRatesApi)
</script>

<template>
  <TableTutorAttendanceRates />
</template>
